import React, { useState, useEffect } from "react";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";
import { useAuth } from "../../Common/Configurations/AuthContext";
import moment from "moment";
import Header from "../../Common/Layout/Header";
import AccountTabs from "../AllTabs/AccountTabs";

const ProfitLossDetailedReport = () => {
  const { user } = useAuth();
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState(moment().startOf("month").format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"));

  const fetchReport = async () => {
    if (!user?.cid) return;
    setLoading(true);
    try {
      const url = `${config.GETPLDETAILEDREPORT}/${user.cid}?fromDate=${fromDate}&toDate=${toDate}`;
      const res = await apiService.getAll(url);
      console.log(res)
      setReport(res);
    } catch (error) {
      console.error("Error fetching P&L:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user?.cid) fetchReport();
  }, [user?.cid]);

  const formatAmount = (val) => Number(val || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 });

  // --- HELPER CALCULATIONS FOR UI ---
  const calculateTotal = (items) => items ? items.reduce((acc, curr) => acc + curr.amount, 0) : 0;

  let totalDirectCosts = 0;
  let totalOperatingCosts = 0;
  let grossProfit = 0;

  if (report) {
    totalDirectCosts = calculateTotal(report.directExpenses);
    totalOperatingCosts = calculateTotal(report.operatingExpenses);
    grossProfit = report.totalRevenue - totalDirectCosts;
  }

  return (
    <div id="layout-wrapper">
       <Header User={user} activeSection="accounts" />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-12">
                <div className="card">
                  {/* 1. TABS SECTION (Exactly like Image 1) */}
                  <div className="p-2">
                    <AccountTabs pageName="PROFITLOSSDETAILEDREPORT" />
                  </div>

                  {/* 2. REPORT CONTENT WRAPPED IN CARD BODY */}
                  <div className="card-body">
                    <div className="report-container">

                      {/* Header Section with Blue Background (Internal content) */}
                      <div className="report-header" style={{ borderRadius: '8px 8px 0 0' }}>
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <h2 className="report-title">Profit & Loss Statement</h2>
                            <div className="report-subtitle text-white">
                              <div>Company: {report?.companyName}</div>
                              <small>GST: {report?.gstNo}</small>
                            </div>
                          </div>

                        </div>

                        <div className="filter-bar">
                          <div className="date-input">
                            <span>From</span>
                            <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                          </div>
                          <div className="date-input">
                            <span>To</span>
                            <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                          </div>
                          <button className="search-button" onClick={fetchReport} disabled={loading}>
                            {loading ? "Loading..." : "GENERATE"}
                          </button>
                        </div>
                      </div>

                      {/* Report Content */}
                      {report && !loading && (
                        <div className="report-body">
                          <table className="pl-table">
                            <thead>
                              <tr>
                                <th style={{ width: '60%' }}>Particulars</th>
                                <th className="text-right">Amount (INR)</th>
                                <th className="text-right">Total (INR)</th>
                              </tr>
                            </thead>
                            <tbody>

                              {/* 1. REVENUE */}
                              {/* <tr className="main-cat">
                  <td colSpan={3}>1. REVENUE (Total Income)</td>
                </tr> */}
                              <tr className="main-cat">
                                <td colSpan={3}>1. SALES</td>
                              </tr>

                              {report.revenues.map((item, i) => (
                                <tr key={i} className="row-item">
                                  <td>{item.name}</td>
                                  <td className="text-right">{formatAmount(item.amount)}</td>
                                  <td></td>
                                </tr>
                              ))}
                              <tr className="total-revenue-row">
                                <td className="bold-text">Total Sales (A)</td>
                                <td></td>
                                <td className="text-right bold-text total-blue">{formatAmount(report.totalRevenue)}</td>
                              </tr>

                              <tr className="spacer"></tr>

                              {/* 2. DIRECT COSTS */}
                              {/* <tr className="main-cat">
                  <td colSpan={3} className="red-text">2. DIRECT COSTS (Cost of Sales)</td>
                </tr> */}
                              <tr className="main-cat">
                                <td colSpan={3} className="red-text">
                                  2. PURCHASES
                                </td>
                              </tr>

                              {report.directExpenses.map((item, i) => (
                                <tr key={i} className="row-item">
                                  <td>{item.name}</td>
                                  <td className="text-right">{formatAmount(item.amount)}</td>
                                  <td></td>
                                </tr>
                              ))}
                              <tr className="total-expense-row">
                                {/* <td className="bold-text">Total Direct Costs (B)</td> */}
                                <td className="bold-text">Total Purchases (B)</td>
                                <td></td>
                                <td className="text-right bold-text total-red">{formatAmount(totalDirectCosts)}</td>
                              </tr>

                              <tr className="spacer"></tr>

                              {/* 3. GROSS PROFIT */}
                              <tr className="sub-cat">
                                <td className="bold-text">
                                  3. GROSS PROFIT (A - B) <br />
                                  <span style={{ fontSize: '11px', fontWeight: 'normal', color: '#888' }}>
                                    (Total Markup + PG Recovery)
                                  </span>
                                </td>
                                <td></td>
                                <td className="text-right bold-text">{formatAmount(grossProfit)}</td>
                              </tr>

                              <tr className="spacer"></tr>

                              {/* 4. OPERATING EXPENSES */}
                              {/* <tr className="main-cat">
                  <td colSpan={3} className="red-text">4. OPERATING EXPENSES (Indirect)</td>
                </tr> */}
                              <tr className="main-cat">
                                <td colSpan={3} className="red-text">
                                  4. EXPENSES
                                </td>
                              </tr>

                              {report.operatingExpenses.map((item, i) => (
                                <tr key={i} className="row-item">
                                  <td>{item.name}</td>
                                  <td className="text-right">{formatAmount(item.amount)}</td>
                                  <td></td>
                                </tr>
                              ))}
                              <tr className="total-expense-row">
                                <td className="bold-text">Total Operating Expenses (C)</td>
                                <td></td>
                                <td className="text-right bold-text total-red">{formatAmount(totalOperatingCosts)}</td>
                              </tr>

                              <tr className="spacer"></tr>

                              {/* 5. NET PROFIT */}
                              <tr className="net-profit-row">
                                <td className="bold-text">5. NET PROFIT (Gross Profit - Expenses)</td>
                                <td></td>
                                <td className="text-right bold-text profit-value">
                                   INR {formatAmount(report.netProfit)}
                                </td>
                              </tr>

                            </tbody>
                          </table>
                        </div>

                      )}
                    </div>

                    <style jsx>{`
        .pl-main-wrapper {
          padding: 30px;
          background-color: #f4f7f6;
          min-height: 100vh;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }
        .report-container {
          background: #ffffff;
          border-radius: 8px;
          box-shadow: 0 4px 15px rgba(0,0,0,0.1);
          overflow: hidden;
          border-top: 5px solid #0056b3; /* BLUE Header Border */
          max-width: 1000px;
          margin: 0 auto;
        }
        .report-header {
          background-color: #0056b3; /* BLUE Background */
          color: white; /* WHITE Text */
          padding: 20px 30px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .report-title { margin: 0; font-size: 24px; font-weight: 600; color: #fff; }
        .company-id { margin: 0; font-size: 13px; opacity: 0.8; margin-top: 5px; }

        .filter-bar { display: flex; gap: 20px; align-items: flex-end; }
        .date-input { display: flex; flex-direction: column; }
        .date-input span { font-size: 11px; font-weight: bold; text-transform: uppercase; margin-bottom: 4px; color: #daeaff; }
        .date-input input { border-radius: 4px; border: none; padding: 6px 10px; font-size: 13px; color: #333; outline: none; }
        .search-button { 
          padding: 8px 20px; 
          background: #ffffff; /* WHITE */
          color: #0056b3; /* BLUE */
          border: none; 
          border-radius: 4px; 
          font-weight: bold; 
          cursor: pointer; 
          transition: 0.3s;
          height: 30px;
        }
        .search-button:hover { background: #ffff; }

        .report-body { padding: 30px; color: #333; /* BLACK text */ }
        .pl-table { width: 100%; border-collapse: collapse; }
        .pl-table th { 
          text-align: left; 
          border-bottom: 2px solid #eee; 
          padding: 12px 10px; 
          color: #777; 
          font-size: 12px; 
          text-transform: uppercase; 
        }
        .pl-table td { padding: 12px 10px; border-bottom: 1px solid #f9f9f9; vertical-align: top; }
        .text-right { text-align: right; }
        .bold-text { font-weight: bold; color: #000; }

        .main-cat td { font-weight: bold; font-size: 16px; background: #fdfdfd; padding-top: 25px; padding-bottom: 10px; }
        .red-text { color: #dc3545; } /* RED Expense Header */
        
        .sub-cat td { color: #0056b3; font-weight: 600; font-size: 14px; padding-top: 20px; }
        .row-item td { padding-left: 25px; color: #444; font-size: 14px; }

        .total-revenue-row td { border-top: 1px solid #0056b3; padding-top: 15px; background-color: #f4faff; }
        .total-blue { color: #0056b3 !important; font-size: 15px; }

        .total-expense-row td { border-top: 1px solid #dc3545; padding-top: 15px; background-color: #fff5f5; }
        .total-red { color: #dc3545 !important; font-size: 15px; }

        .net-profit-row td { 
          background: #f0f7ff; 
          border-top: 2px solid #0056b3; 
          padding: 20px 10px; 
          font-size: 18px; 
        }
        .profit-value { color: #28a745 !important; } /* GREEN for profit profit */
        .spacer td { height: 20px; border: none; }
      `}</style>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default ProfitLossDetailedReport;